import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { EntidadService } from "../../providers/entidad.service";
import { MaterialModule } from "../../components/material/material.module";
import { PipesModule } from "../../pipes/pipes.module";
import { EntidadComponent } from "./entidad.component";
import { EntidadResponsableModule } from "./entidad-responsables/entidad-responsable.module";
import { ContactoModule } from "./contactos/contacto.module";
import { ImageUploadModule } from "../../components/archivos/image-upload.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        EntidadResponsableModule,
        ContactoModule,
        ImageUploadModule.forRoot()
    ],
    declarations: [
        EntidadComponent
    ],
    providers: [
        EntidadService
    ],
    entryComponents: [
    ],
    exports: [
        EntidadComponent
    ]
})
export class EntidadModule { }